module.exports = __webpack_public_path__ + "assets/img/banner-18.17d8c0cf.jpg";